import { Avatar, Tooltip } from "antd";
import React from "react";
import type Parse from "parse";

interface Props {
  user: Parse.User | null | undefined;
}

export function UserBadge({ user }: Props) {
  if (!user) return null;
  const username: string = (user as any).get?.("username") ?? (user as any).username ?? "?";
  const initial = username.charAt(0).toUpperCase();
  return (
    <Tooltip title={username}>
      <Avatar size="small" style={{ backgroundColor: stringToColor(username), fontSize: 11 }}>
        {initial}
      </Avatar>
    </Tooltip>
  );
}

function stringToColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 55%, 50%)`;
}
